import { IonCardContent, IonCol, IonGrid, IonItem, IonLabel, IonRow, IonText } from '@ionic/react';
import { IRepairOrder } from '../../../models/dms/repairOrder.model';
import { IonListWrapper } from './PartAssetDetails.styles';

interface IComponentProps {
  repairOrder: IRepairOrder;
}

const PartAssetDetails: React.FC<IComponentProps> = ({ repairOrder }) => {
  return (
    <IonListWrapper>
      {/* Header */}
      <IonItem>Part Details</IonItem>

      {/* Data */}
      <IonItem lines="none">
        <IonCardContent>
          <IonGrid>
            <IonRow>
              <IonCol size="auto">
                <IonItem>
                  <IonLabel position="stacked">Part Number</IonLabel>
                  <IonText class="flexed flexed-center">{repairOrder?.vehicle?.sourceRef || ''}</IonText>
                </IonItem>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCardContent>
      </IonItem>
    </IonListWrapper>
  );
};

export default PartAssetDetails;
